import { FaEye } from 'react-icons/fa';
import { useRescheduleHistoryContext } from '../../../contexts/RescheduleHistoryProvider';
import { RescheduleHistory } from '../../../types/history';

const ViewRescheduleDetails = ({
  rescheduleHistory,
}: {
  rescheduleHistory: RescheduleHistory;
}) => {
  // integration of context hooks here
  const { setShowDetailsModal, setRescheduleHistory } =
    useRescheduleHistoryContext();

  // handler function to handle showing details modal declared here
  const showDetailsModalHandler = () => {
    setShowDetailsModal(true);
    setRescheduleHistory(rescheduleHistory);
  };

  // rendering view reschedule details component here
  return (
    <div className='flex items-center justify-center'>
      <button
        onClick={showDetailsModalHandler}
        className='flex items-center justify-center gap-2 bg-base-cyan text-base-white font-medium text-sm px-4 py-1 rounded-md shadow-academia-sm hover:opacity-70 active:scale-95 duration-300'
      >
        <FaEye />
        View Details
      </button>
    </div>
  );
};

export default ViewRescheduleDetails;
